import React from 'react';

// material-ui
import { Box, Paper, Typography } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';

// project imports
import MenuList from './MenuList';
import logoLeapBranco from '../../../assets/leaplogoblackandwhite.png';
import smallLogoLeap from "../../../assets/Badge.svg";
import { SectionLogo, LogoImagem } from './styles';

import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { styled } from '@mui/material';
import { drawerWidth } from '../../../context/customizationSlice/types';
import { getCookie } from '../../../utils';

import imgLogin from '../../../assets/imgs/img-login.png';

// ==============================|| SIDEBAR DRAWER ||============================== //

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    background: '#181818',
    color: '#ffff',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    background: '#181818',
    color: '#ffff',
    width: 95,
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerOpen' })(
    ({ theme, open }) => ({
        width: open ? '88px' : drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
    const usuarioLogado = getCookie("authToken");

    const styledClose = {
        zIndex: 99999,
        position: 'fixed',
        border: '1px solid',
        left: 90
    }

    //https://codesandbox.io/s/fxxfk0?file=/demo.tsx:1346-1357
    return (
        <Drawer variant="permanent" open={drawerOpen} className='d-print-none'>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: 'auto',
                        minHeight: '100vh',
                        paddingLeft: '16px',
                        paddingRight: '16px',
                        background: '#181818',
                        color: '#ffff'
                    }}
                >
                    <SectionLogo drawerOpen={drawerOpen}>
                        <div className='w-full flex flex-row items-center'>
                            <img src={imgLogin} className='w-10 mr-2' />
                            <Typography className='text-bold'>Bem vindo, {usuarioLogado?.user?.login}</Typography>
                        </div>
                        <Paper className="expand-btn" onClick={() => drawerToggle()} style={!drawerOpen ? styledClose : null}>
                            {drawerOpen ? (
                                <KeyboardDoubleArrowLeftIcon style={{ color: 'black' }} />
                            ) : (
                                <KeyboardDoubleArrowRightIcon style={{ color: 'black' }} />
                            )}
                        </Paper>
                    </SectionLogo>

                    <MenuList />
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                <SectionLogo drawerOpen={drawerOpen}>
                    <LogoImagem component='img' drawerOpen={drawerOpen} src={drawerOpen ? logoLeapBranco : smallLogoLeap} />
                    <Paper className="expand-btn" onClick={() => drawerToggle()}>
                        {drawerOpen ? (
                            <KeyboardDoubleArrowLeftIcon />
                        ) : (
                            <KeyboardDoubleArrowRightIcon />
                        )}
                    </Paper>
                </SectionLogo>
                <Box sx={{ px: 2 }}>
                    <MenuList />
                </Box>
            </MobileView>
        </Drawer>
    )
};

export default Sidebar;
